module.exports = "/davinci/assets/4f1a06fffb540c0be286b82d53f4e180.png";